import React, { useState, useRef } from "react";
import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";

import Preloader from "@/components/site/Preloader";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import { VisionMission, WhyKhadi, NationalImpact } from "@/components/site/Manifesto";
import { DesignChallenge, KnowledgeSeries, Ambassadors, MediaAndCSR } from "@/components/site/Programs";
import Sponsorship from "@/components/site/Sponsorship";
import { GrandFinale, ClosingCTA, Contact, Footer } from "@/components/site/Finale";

function App() {
  const [ready, setReady] = useState(false);
  const regRef = useRef(null);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App grain bg-[#f2ece0]">
        <Preloader onDone={() => setReady(true)} />
        <Nav ready={ready} />
        <main>
          <Hero start={ready} />
          <Marquee items={["Heritage", "Sustainability", "Craft", "Innovation", "Made in India"]} />
          <VisionMission />
          <WhyKhadi />
          <NationalImpact />
          <DesignChallenge openRef={regRef} />
          <Marquee dark items={["Design", "Educate", "Empower", "Showcase", "Celebrate"]} />
          <KnowledgeSeries />
          <Ambassadors />
          <MediaAndCSR />
          <Sponsorship />
          <GrandFinale />
          <ClosingCTA />
          <Contact />
          <Footer />
        </main>
        <Toaster position="bottom-right" />
      </div>
    </ReactLenis>
  );
}

export default App;
